<template lang="pug">
  include /mixins
  +b.ds-panel--space_sm.tt-space_mt--3
    +e.element--indent_outside.--offset_vertical.relative
      ui-loader(
        v-if='isPageLoading'
      )
      slot(
        v-if='limit > list.length'
        name='loader',
        :addVideo='addVideo'
        :addPhoto='addPhoto'
      )
        +b.participant-education-document-loader(
          @dragover.prevent="handleDragOver"
          @drop.prevent="handleDrop"
          @dragenter.prevent
          @dragleave="handleDragLeave"
          :class='cellSize'
        )
          +e.content
            +e.icon.SVG(width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg")
              path(d="M14.9995 2H5.5C4.67157 2 4 2.67157 4 3.5V20.5C4 21.3284 4.67157 22 5.5 22H18.5C19.3284 22 20 21.3284 20 20.5V7.49902M14.9995 2V5.99902C14.9995 6.82745 15.6711 7.49902 16.4995 7.49902L20 7.49902M14.9995 2L20 7.49902" stroke="#1A1A1A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round")
            +e.title.P {{ _('Перетащите файлы сюда или') }}
              label(:for='id') {{ _('выберите его') }}
            //- +e.text.SPAN {{ _('.jpg. .png') }}
            input.visually-hidden(
              type="file"
              name="img"
              :accept="accept"
              :invalid='!list.length || list.some(el => el.err)'
              :data-max='sizeLimit'
              ref='img'
              @change='addPhoto($event)'
              :id='id',
              :multiple='limit > 1'
            )
      +b.g-row--space_lg.--appearance_spaced
        template(v-for='(imagesitem, index) in list')
          +b.g-cell.g-cols--12(
            :class='cellSize'
          )
            slot(name='item', :item='imagesitem')
              component(
                :is='getTypeComponent(imagesitem)'
                :item='imagesitem'
                @removeItem='removeImage($event)'
                :idx='index'
                :filekey='filekey'
                :extentions='extentions'
              )

        //- +b.g-cell.g-cols--12(v-if='imgLengthErr')
        //-   +b.LABEL.error--top(
        //-     v-if='imgLengthErr'
        //-     class="help"
        //-   )  {{ imgLengthErr }}
</template>
<script>
// import mime from 'mime-type';

import {
  confirmWithPromise,
  getId,
} from '@utils/helpers'
import GalleryItem from './GalleryItem'
import FileViewer from './FileViewer'

import { isHeic, heicTo } from "heic-to"
import { asyncForEach } from '@utils/async'
const SPLITED_LENGTH = 1
const IMAGE_EXTENSIONS = [
  'jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'bmp', 'heic', 'heif',
]

export default {
  name: 'Gallery',
  components: {
    GalleryItem,
    FileViewer,
  },
  props: {
    id: {},
    filekey: {
      default: 'img',
    },
    limit: {
      type: Number,
      default: 5,
    },
    sizeLimit: {
      type: Number,
      default: 20480000,
    },
    resource: {
    },
    reset: {

    },
    additional: {},
    getResource: {},
    postResource: {},
    patchResource: {},
    deleteResource: {},
    profile: {},
    accept: {
      default: '*/*',
    },
    cellSize: {
      default: '12',
    },
    extentions: {
      default: () => ([]),
    },
    initial: {},
    ticket_hash: {},
    ticket: {},
  },
  data() {
    return {
      test: '',
      value: [],
      isPageLoading: false,
      list: [],
      nonFieldError: '',
      isBlocked: false,
      files: [],
      one: 1,
      full: 100,
      imgLengthErr: '',
      file: null,
      localImage: null,
      isDragOver: false,
      isLoad: false,
    }
  },
  watch: {
    reset(nval) {
      if (nval) {
        this.list = []
        this.files = []
      }
    },
  },
  created() {
    this.getInit()
  },
  methods: {
    handleDragOver(event) {
      event.preventDefault();
      this.isDragOver = true;
      // Добавим следующую строку, чтобы предотвратить открытие изображения в новой вкладке
      event.dataTransfer.dropEffect = 'copy';
    },
    handleDragLeave() {
      this.isDragOver = false;
    },
    async convertHeicToJpeg(file) {
      const isH = (await isHeic(file))
      console.log(isH, 'isHeic');
      if (!isH) return file

      const jpeg = await heicTo({
        blob: file,
        type: 'image/jpeg',
        quality: 0.9,
      })
      console.log(jpeg, 'JPEG');
      return new File(
        [jpeg],
        file.name.replace(/\.(heic|heif)$/i, '.jpg'),
        { type: 'image/jpeg' }
      )
    },
    async handleDrop(e) {
      this.isPageLoading = true
      const err = this._('Максимальный размер файла - ') + this.sizeLimit / 1024000 + this._('мб')

      const files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      await asyncForEach(Array.from(files), async (f) => {
        this.imgLengthErr = ''
        let file = f
        try {
          console.log(f, '1111');
          file = await this.convertHeicToJpeg(f)
          console.log(file, ">22222?>>>>>>>>>>>");
          this.list.push({
            img: window.URL.createObjectURL(file),
            progressBarWidth: 0,
            err: file.size > this.sizeLimit ? err : false,
            val: false,
            type: file.type,
            file,
          })
        } catch (error) {
          console.log(error);
        }
      })
      this.isPageLoading = false
      this.files = files
      this.loader()
    },
    tofile(file) {
      if (!file) return Promise.reject()

      return Promise.resolve({
        file, img: window.URL.createObjectURL(file),
      })
    },
    getTypeComponent(item) {
      return this.isImageItem(item) ? 'GalleryItem' : 'FileViewer'
    },
    fileTypeChecker(file) {
      return file && file.type
    },
    isImageItem(item) {
      const type = this.fileTypeChecker(item.file) || item.type
      if (type && type.includes('/')) return type.includes('image/')
      return IMAGE_EXTENSIONS.includes(this.getItemExtension(item))
    },
    getItemExtension(item) {
      const source = (item.file && item.file.name) ||
        ('string' === typeof item.file ? item.file : '') ||
        item.title ||
        ''
      const matched = String(source).split('?')[0].match(/\.([a-z0-9]+)$/i)
      return matched ? matched[1].toLowerCase() : ''
    },
    normalizeItem(item) {
      if (
        item && item.props &&
        'undefined' === typeof item.file &&
        'undefined' === typeof item.img
      ) {
        return { ...item.props }
      }
      return item
    },
    async getInit() {
      if (!this.getResource) {
        this.list = (this.initial || []).map(el => this.normalizeItem(el))
        return
      }
      const { items } = (await this.getResource.execute())
      this.list = items.map(el => this.normalizeItem(el))
    },
    addVideo(event) {
      // this.handleDrop(event)
      this.$emit('inProcess', true)
      this.nonFieldError = ''
      this.isBlocked = true
      const video = getId(event)
      this.showVideoRow = false

      const image = `https://img.youtube.com/vi/${video}/0.jpg`
      this.list.push({
        img: image,
        progressBarWidth: 0,
        file: event,
        type: 'image/',
      })
      this.loader()
    },
    addPhoto(event) {
      // this.$emit('inProcess', true)
      this.handleDrop(event)
      // this.nonFieldError = ''
      // this.imgLengthErr = ''
      // this.isBlocked = true

      // const files = Array.from(event.target.files)

      // const err = this._('Максимальный размер файла - ') + this.sizeLimit / 1024000 + this._('мб')

      // this.files = files
      // files.forEach(file => {
      //   this.list.push({
      //     img: window.URL.createObjectURL(file),
      //     progressBarWidth: 0,
      //     err: file.size > this.sizeLimit ? err : false,
      //     val: false,
      //     type: file.type,
      //     file,
      //   })
      // })
      // this.loader()
    },
    loader() {
      this.list.forEach((element, index) => {
        if (element.err) return
        this.$emit('load', true)
        if (element.id) return
        if (this.postResource) {
          this.postResource.execute({
            label: this.ticket_hash,
          }, {
            ...this.additional,
            [this.filekey]: element.file,
            title: element.file.name,
          }).then(({ data: { item: { id } } }) => {
            this.$set(this.list[index], 'id', id)
            this.$emit('update', this.list)
            this.$emit('load', false)
          }, err => {
            this.$emit('load', false)
            if (err && err.json) {
              err.json().then(body => {
                const errors = body.errors || []
                let message = ''
                errors.forEach(e => {
                  if (e.state) {
                    const key = Object.keys(e.state)[0]
                    if (key && e.state[key][0]) message = e.state[key][0].message
                  } else if (e.message) {
                    message = e.message
                  }
                })
                if (message) this.$set(this.list[index], 'err', message)
              })
            }
          })
          return
        }
        this.$emit('update', this.list)
      })
    },
    async removeImage(i) {
      const question = this._('Вы действительно хотите удалить?')
      try {
        await confirmWithPromise(question, this)
        if (this.list[i].id) {
          this.deleteResource.execute({ label: this.ticket_hash, id: this.list[i].id })
        }
        this.list.splice(i, SPLITED_LENGTH)
        this.$emit('update', this.list)
      } catch (e) {
        console.log(e);
      }
    },
  },

}
</script>
